module.exports = __webpack_public_path__ + "img/2_69.0d118c67.png";